import LeadsTransferPage from "./lead-transfer/pages/LeadsTransferPage";

export default LeadsTransferPage;
